export default __webpack_public_path__ + "images/068490d0d2b62a9bce349736566142ea.jpg";